import { useState, useEffect } from 'react';
import { decodeBase64Value, handleUnexpectedException } from 'src/helpers/functions';
import { networkProvider } from 'src/utils/networkProvider';
import { smartContract } from 'src/utils/smartContract';

function useAvailableWithdraw(userAddress) {
    const [availableWithdraw, setAvailableWithdraw] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchAvailableWithdraw = async () => {
            try {
                const interaction = smartContract.methods.availableWithdraw([userAddress]);
                const query = interaction.check().buildQuery();
                const queryResponse = await networkProvider.queryContract(query);
                const withdrawAmount = queryResponse.returnData[0] || 0;

                setAvailableWithdraw(decodeBase64Value(withdrawAmount) || 0);
            } catch (err) {
                handleUnexpectedException(err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        if (userAddress) {
            fetchAvailableWithdraw();
        }
    }, [userAddress]);

    return { availableWithdraw, loading, error };
}

export default useAvailableWithdraw;
